import React from 'react';
import { goBack } from 'react-router-redux';
import { RaisedButton } from 'material-ui';
import { connect } from 'react-redux';

@connect()
export default class extends React.Component {
  backLogin = () => (this.props.exitQuestion ? this.props.exitQuestion(goBack()) : this.props.dispatch(goBack()));
  render() {
    return <RaisedButton label="Cancelar" onTouchTap={this.backLogin} fullWidth={true} backgroundColor="#E53935" labelColor="white" className="cancelarButtom" />;
  }
}



// WEBPACK FOOTER //
// src/modules/general/components/cancelarButton.js